var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2 56C84.72 59.34 88 63.5 88 68C88 79.05 68.3 88 44 88C19.7 88 0 79.05 0 68C0 63.5 3.28 59.34 8.8 56C3.28 52.66 0 48.5 0 44C0 39.5 3.28 35.34 8.8 32C3.28 28.66 0 24.5 0 20C0 8.95 19.7 0 44 0C68.3 0 88 8.95 88 20C88 24.5 84.72 28.66 79.2 32C84.72 35.34 88 39.5 88 44C88 48.5 84.72 52.66 79.2 56Z",
    fill: "#62246B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon09);
export default __webpack_public_path__ + "static/media/icon_09.e4e6968303d7e6340758489a61358114.svg";
export { ForwardRef as ReactComponent };